import { SVGProps } from 'react';

const Hotel = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M21 18.75a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h18Zm-1.75-3.459a.347.347 0 0 0-.237-.33c-.767-.255-1.22-.951-1.308-1.656-.129-1.038-.543-2.311-1.417-3.31C15.436 9.018 14.103 8.25 12 8.25s-3.436.77-4.288 1.744c-.874 1-1.288 2.273-1.417 3.31-.088.706-.54 1.402-1.308 1.658a.347.347 0 0 0-.237.329v.047c0 .228.185.412.412.412h13.676a.412.412 0 0 0 .412-.412v-.047ZM2.788 8.263a.75.75 0 0 1 .95-.475l1.5.5a.75.75 0 0 1-.475 1.424l-1.5-.5a.75.75 0 0 1-.475-.95Zm17.475-.475a.75.75 0 0 1 .474 1.424l-1.5.5a.75.75 0 0 1-.474-1.424l1.5-.5ZM5.084 5.376a.75.75 0 0 1 1.04.208l1 1.5a.75.75 0 1 1-1.248.832l-1-1.5a.75.75 0 0 1 .208-1.04Zm12.792.208a.75.75 0 1 1 1.248.832l-1 1.5a.75.75 0 1 1-1.248-.832l1-1.5Zm2.874 9.754a1.912 1.912 0 0 1-1.912 1.912H5.162a1.912 1.912 0 0 1-1.912-1.912v-.047c0-.795.509-1.502 1.263-1.753.129-.043.265-.186.294-.418.154-1.244.652-2.827 1.775-4.113C7.61 7.83 9.126 6.95 11.25 6.78V5.75H10a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5h-1.25v1.031c2.124.169 3.64 1.05 4.668 2.226 1.123 1.286 1.62 2.869 1.775 4.113.03.232.165.375.294.418a1.848 1.848 0 0 1 1.263 1.753v.047Z"
    />
  </svg>
);

export default Hotel;
